import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import AlertModal from "../Components/AlertModal";

const AlertModalContext = createContext(null);

export const useAlertModal = () => {
  const ctx = useContext(AlertModalContext);
  if (!ctx) return { showAlert: (title, body) => window.alert(title) };
  return ctx;
};

export const AlertModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const showAlert = useCallback((titleOrMessage, bodyText) => {
    const t = typeof titleOrMessage === "string" ? titleOrMessage : "Notice";
    const b = typeof bodyText === "string" ? bodyText : "";
    setTitle(t);
    setBody(b);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    setTitle("");
    setBody("");
  }, []);

  useEffect(() => {
    const originalAlert = window.alert;
    window.alert = (msg) => {
      showAlert(String(msg));
    };
    return () => {
      window.alert = originalAlert;
    };
  }, [showAlert]);

  return (
    <AlertModalContext.Provider value={{ showAlert }}>
      {children}
      <AlertModal open={open} title={title} body={body} onClose={handleClose} />
    </AlertModalContext.Provider>
  );
};
